import React from "react";
import styles from "../assets/css/home.module.css";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  const handleScanShipments = () => {
    navigate("/scan-shipments");
  };
  const handleScanPickups = () => {
    navigate("/scan-pickups");
  };

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={handleScanShipments}>
          Scan Shipments
        </button>
        <button className={styles.button} onClick={handleScanPickups}>
          Scan Pickups
        </button>
      </div>
    </div>
  );
}
